/** Dock flottant façon macOS — bascule des calques thématiques. */
import { Home, TrendingUp, Wallet, Briefcase, Sparkles } from 'lucide-react';

export const LAYERS = [
  { key: 'immobilier', label: 'Immobilier', icon: Home, color: '#D9A05B' },
  { key: 'bourse', label: 'Bourse', icon: TrendingUp, color: '#38BDF8' },
  { key: 'liquidites', label: 'Liquidités', icon: Wallet, color: '#34D399' },
  { key: 'pro', label: 'Projets pro', icon: Briefcase, color: '#A78BFA' },
];

export const Dock = ({ active, onSelect, majordomeOpen, onToggleMajordome }) => (
  <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-[700] flex items-end gap-1 px-3 py-2 rounded-2xl"
       style={{ background: 'rgba(16,17,22,0.55)', backdropFilter: 'blur(18px)', border: '1px solid rgba(255,255,255,0.12)', boxShadow: '0 18px 50px rgba(0,0,0,0.55)' }}
       data-testid="patrimoine-dock">
    {LAYERS.map((l) => {
      const Icon = l.icon;
      const isActive = active === l.key;
      return (
        <button key={l.key} type="button" onClick={() => onSelect(l.key)}
                title={l.label} data-testid={`dock-layer-${l.key}`}
                className="group relative flex flex-col items-center transition-transform duration-150 hover:-translate-y-2 hover:scale-110"
                style={{ width: 56 }}>
          <span className="pointer-events-none absolute -top-7 px-2 py-0.5 rounded text-[10px] font-semibold opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap"
                style={{ background: 'rgba(10,10,13,0.9)', color: '#E5E7EB', border: '1px solid rgba(255,255,255,0.12)' }}>
            {l.label}
          </span>
          <span className="w-11 h-11 rounded-xl flex items-center justify-center transition-colors"
                style={{
                  background: isActive ? `${l.color}2E` : 'rgba(255,255,255,0.06)',
                  border: `1px solid ${isActive ? `${l.color}80` : 'rgba(255,255,255,0.08)'}`,
                }}>
            <Icon className="w-5 h-5" style={{ color: isActive ? l.color : '#9CA3AF' }} />
          </span>
          <span className="mt-1 w-1 h-1 rounded-full transition-opacity"
                style={{ background: l.color, opacity: isActive ? 1 : 0 }} />
        </button>
      );
    })}
    <div className="w-px self-stretch mx-1.5 my-1" style={{ background: 'rgba(255,255,255,0.12)' }} />
    <button type="button" onClick={onToggleMajordome} title="Majordome IA"
            data-testid="dock-majordome-btn"
            className="group relative flex flex-col items-center transition-transform duration-150 hover:-translate-y-2 hover:scale-110"
            style={{ width: 56 }}>
      <span className="w-11 h-11 rounded-xl flex items-center justify-center"
            style={{
              background: majordomeOpen ? 'rgba(217,160,91,0.2)' : 'rgba(255,255,255,0.06)',
              border: `1px solid ${majordomeOpen ? 'rgba(217,160,91,0.6)' : 'rgba(255,255,255,0.08)'}`,
            }}>
        <Sparkles className="w-5 h-5" style={{ color: majordomeOpen ? '#D9A05B' : '#9CA3AF' }} />
      </span>
      <span className="mt-1 w-1 h-1 rounded-full" style={{ background: '#D9A05B', opacity: majordomeOpen ? 1 : 0 }} />
    </button>
  </div>
);
